module.exports = __webpack_public_path__ + "img/3.a25b0f9b.png";